import React from 'react';
import type { SelectProps } from 'core/components/ui';
import { Select } from 'core/components/ui';
import { getOptions, objectEntries } from 'core/utils';

export function withSelectEnumHOC(enumTypes: any, isReversed = false, transformLabel?: any) {
  const options = getOptions(objectEntries(enumTypes), isReversed, transformLabel);

  return function (props: SelectProps) {
    return <Select options={options} {...props} />;
  };
}
